import React from "react";

import { OrderStatusCounts } from "../../types/dashboard";

interface OrderStatusChartProps {
  data: OrderStatusCounts;
}

// Status colors, will match with database colors later
const statusColors = {
  new: "#3498db", // Blue
  processing: "#f39c12", // Orange
  ready: "#2ecc71", // Green
  out_for_delivery: "#9b59b6", // Purple
  delivered: "#27ae60", // Dark Green
  picked_up: "#27ae60", // Dark Green (same as delivered)
  cancelled: "#e74c3c", // Red
};

const OrderStatusChart: React.FC<OrderStatusChartProps> = ({ data }) => {
  // Calculate percentages for each status
  const total = data.total || 1; // Prevent division by zero

  const statuses = [
    { name: "New", count: data.new, color: statusColors.new },
    {
      name: "Processing",
      count: data.processing,
      color: statusColors.processing,
    },
    { name: "Ready", count: data.ready, color: statusColors.ready },
    {
      name: "Out for Delivery",
      count: data.out_for_delivery,
      color: statusColors.out_for_delivery,
    },
    { name: "Delivered", count: data.delivered, color: statusColors.delivered },
    { name: "Picked Up", count: data.picked_up, color: statusColors.picked_up },
    { name: "Cancelled", count: data.cancelled, color: statusColors.cancelled },
  ];

  return (
    <div className="space-y-6">
      {/* Visual bar chart */}
      <div className="h-6 rounded-full bg-gray-200 dark:bg-gray-700 overflow-hidden flex">
        {statuses.map((status, index) => {
          const percentage = (status.count / total) * 100;

          // Don't render if 0%
          if (percentage === 0) return null;

          return (
            <div
              key={index}
              className="h-full"
              style={{
                width: `${percentage}%`,
                backgroundColor: status.color,
                transition: "width 0.7s ease-in-out",
              }}
              title={`${status.name}: ${status.count} (${percentage.toFixed(1)}%)`}
            />
          );
        })}
      </div>

      {/* Legend */}
      <div className="grid grid-cols-2 sm:grid-cols-3 gap-4">
        {statuses.map((status, index) => (
          <div key={index} className="flex items-center">
            <div
              className="w-3 h-3 rounded-full mr-2"
              style={{ backgroundColor: status.color }}
            />
            <span className="text-gray-800 dark:text-gray-200 text-sm flex-1">
              {status.name}
            </span>
            <span className="text-gray-600 dark:text-gray-400 text-sm font-semibold">
              {status.count}
            </span>
          </div>
        ))}
      </div>

      {/* Summary */}
      <div className="text-center pt-2 border-t border-gray-200 dark:border-gray-700">
        <span className="text-lg font-bold text-gray-800 dark:text-gray-200">
          {data.total} orders total
        </span>
      </div>
    </div>
  );
};

export default OrderStatusChart;
